/** AUTH */

export const USER_ROLES = {
  SUPER_ADMIN: 'super_admin',
  ADMIN: 'admin',
  CLEANER: 'cleaner',
  MEMBER: 'member',
  PROPERTY_MANAGER: 'property_manager',
  HOUSE_KEEPER: 'house_keeper'
};

/** BOOKINGS */

export const BOOKING_STAGE = {
  RECIPIENT: 'recipient',
  FREQUENCY: 'frequency',
  SERVICE_TYPE: 'serviceType',
  ADDON: 'addon',
  SERVICE_DATE: 'cleanDate',
  TIMEFRAME: 'Timeframe',
  SIGN_KEY: 'signKey',
  CONFIRM: 'confirm',
  ADJUST: 'adjust',
  INSTRUCTIONS: 'instructions'
};

export const FREQUENCIES = {
  ONCE: 'once',
  REGULARLY: 'regularly'
};

export const SERVICE_TYPES = {
  DEEP_CLEAN: 'deep-clean',
  HOTEL_STYLE: 'hotel-style',
  MOVE_OUT: 'move-out'
};

export const ADDONS = {
  FRIDGE: 'fridge-clean',
  LAUNDRY: 'laundry-clean',
  WINDOW: 'window-clean',
  OVEN: 'oven-clean',
  MOPPING: 'mopping-clean',
  BATHROOM: 'bathroom-clean'
};

export const ADDON_TITLES = {
  'laundry-clean': 'Fold Laundry',
  'fridge-clean': 'Clean Fridge',
  'oven-clean': 'Scrub Oven',
  'window-clean': 'Interior Windows',
  'mopping-clean': 'Mop floors',
  'bathroom-clean': 'Bathroom'
};

export const TIME_FRAME = {
  ANYTIME: 'anytime',
  MORNING: 'morning',
  AFTERNOON: 'afternoon'
};

export const TIME_FRAME_TITLES = {
  [TIME_FRAME.ANYTIME]: 'Any time',
  [TIME_FRAME.MORNING]: 'Morning preferred',
  [TIME_FRAME.AFTERNOON]: 'Afternoon preferred'
};

export const COUPON_TYPES = {
  FIXED_AMOUNTINGLE: 'fixed_amount',
  PERCENTAGE: 'percentage'
};

/** CLEANS */

export const CLEANS_STAGE = {
  HOME: 'home',
  DETAIL: 'detail'
};

export const CLEANS_LIST_TYPE = {
  ALL: 'All',
  PAST: 'Completed',
  FUTURE: 'Coming Up'
};

export const SURCHARGE_TEXT = `*The Minte has implemented a 
COVID-19 Safety Surcharge of $2.50
on every clean to cover the added costs of keeping our
housekeepers and your home safe.`;

/* Blooking flow */

export const findNextStep = (
  { bookingStep, selectedFrequency, isPMUser, isKeyReleaseSigned },
  data
) => {
  let step = '';
  let snack = null;
  let redirect = null;

  switch (bookingStep) {
    case BOOKING_STAGE.RECIPIENT:
      step = BOOKING_STAGE.FREQUENCY;
      break;
    case BOOKING_STAGE.FREQUENCY:
      step = BOOKING_STAGE.SERVICE_TYPE;
      break;
    case BOOKING_STAGE.SERVICE_TYPE:
      step = BOOKING_STAGE.ADDON;
      break;
    case BOOKING_STAGE.ADDON:
      {
        if (selectedFrequency === FREQUENCIES.REGULARLY) {
          step = BOOKING_STAGE.TIMEFRAME;
        } else {
          step = BOOKING_STAGE.SERVICE_DATE;
        }
      }
      break;
    case BOOKING_STAGE.TIMEFRAME:
      step = BOOKING_STAGE.SERVICE_DATE;
      break;
    case BOOKING_STAGE.SERVICE_DATE:
    case BOOKING_STAGE.ADJUST: {
      step = BOOKING_STAGE.CONFIRM;
      break;
    }
    case BOOKING_STAGE.SIGN_KEY:
      if (selectedFrequency === FREQUENCIES.REGULARLY) {
        snack = {
          message: 'Service is successfully created',
          theme: 'success'
        };
        redirect = '/';
        break;
      }
      step = BOOKING_STAGE.INSTRUCTIONS;
      break;
    case BOOKING_STAGE.CONFIRM: {
      if (isKeyReleaseSigned || isPMUser) {
        if (selectedFrequency === FREQUENCIES.REGULARLY) {
          snack = {
            message: 'Service is successfully created',
            theme: 'success'
          };
          redirect = '/';
          break;
        }
        step = BOOKING_STAGE.INSTRUCTIONS;
        break;
      } else {
        step = BOOKING_STAGE.SIGN_KEY;
        break;
      }
    }
    case BOOKING_STAGE.INSTRUCTIONS:
      if (data) {
        snack = {
          message: 'Service is successfully created with note',
          theme: 'success'
        };
      } else {
        snack = {
          message: 'Service is successfully created',
          theme: 'success'
        };
      }

      redirect = '/';
      break;
    default:
  }

  return {
    snack,
    step,
    redirect
  };
};

export const findPrevStep = ({
  bookingStep,
  isPMUser,
  selectedServiceType,
  isFromAccount
}) => {
  let step = '';
  let redirect = null;

  switch (bookingStep) {
    case BOOKING_STAGE.RECIPIENT:
      redirect = 'BACK';
      break;
    case BOOKING_STAGE.FREQUENCY:
      if (isPMUser) {
        step = BOOKING_STAGE.RECIPIENT;
      } else {
        redirect = 'BACK';
      }
      break;
    case BOOKING_STAGE.SERVICE_TYPE:
      step = BOOKING_STAGE.FREQUENCY;
      break;
    case BOOKING_STAGE.ADDON:
      step = BOOKING_STAGE.SERVICE_TYPE;
      break;
    case BOOKING_STAGE.TIMEFRAME:
    case BOOKING_STAGE.SIGN_KEY:
      step = BOOKING_STAGE.CONFIRM;
      break;
    case BOOKING_STAGE.SERVICE_DATE:
      if (selectedServiceType === SERVICE_TYPES.MOVE_OUT) {
        if (isFromAccount) {
          redirect = 'BACK';
        } else {
          step = BOOKING_STAGE.FREQUENCY;
        }
      } else {
        step = BOOKING_STAGE.ADDON;
      }
      break;
    case BOOKING_STAGE.ADJUST:
    case BOOKING_STAGE.CONFIRM:
      step = BOOKING_STAGE.SERVICE_DATE;
      break;
    default:
  }
  return {
    step,
    redirect
  };
};

export const DEFAULT_BEDROOM_COUNTS = [0, 1, 2, 3, 4];

export const ALL_PROPETY = {
  propertyID: 0
};
